import { useMemo } from "react";
import UnitHourHistory from "../features/quick-details/unit-hour-history/UnitHourHistory";
import AddCriticalLogs from "../features/reports/critical-logs/add-critical-logs/AddCriticalLogs";
import HoldManagement from "../features/management/HoldManagement";
import SelectImage from "./SelectImage";
import EditSample from "../forms/EditSample";
import AccessPermissionOverview from "../features/reports/critical-logs/access-permission-overview/AccessPermissionOverview";
import SampleReportsOverview from "../features/management/sample-report-overview/SampleReportsOverview";
import EditUnit from "../forms/EditUnit";
import EditSite from "../forms/EditSite";
import EditCustomer from "../forms/EditCustomer";
import SubscriptionReports from "./SubscriptionReports";
import PrimaryContactOverview from "../features/management/primary-contact-overview/PrimaryContactOverview";
import ContactExports from "../features/reports/critical-logs/contact-permission-overview/ContactExports";
import EditComponent from "../forms/EditComponent";
import EditEvent from "../features/events/EditEvent";
import SubscriptionOverview from "../features/quick-details/subscription/SubscriptionOverview";
import ComponentsRecentSamples from "../features/quick-details/recent-samples/ComponentsRecentSamples";
import UnitsRecentSamples from "../features/quick-details/recent-samples/UnitsRecentSamples";
import RecentUnitResults from "../features/quick-details/recent-unit-result/RecentUnitResults";
import ManageCustomer from "../features/quick-details/manage/manage-customer/ManageCustomer";
import ManageSample from "../features/quick-details/manage/manage-sample/ManageSample";
import ManageSite from "../features/quick-details/manage/manage-site/ManageSite";
import ManageUnit from "../features/quick-details/manage/manage-unit/ManageUnit";
import ManageComponent from "../features/quick-details/manage/manage-component/ManageComponent";
import RecentComponentResults from "../features/quick-details/recent-component-result/RecentComponentResults";
import SearchRegistration from "../features/quick-details/registrations/SearchRegistration";
import SearchFluid from "../features/master-data/fluids/SearchFluid";
import SearchGeneral from "../features/details-old-copy/SearchGeneral";
import EditTray from "../forms/EditTray";
import SpecialReport from "../forms/SpecialReport";
import UpdateTrayLabel from "../forms/UpdateTrayLabel";
import ManagementReport from "../features/management/ManagementReport";
import EditBillingRates from "../features/management/EditBillingRates";
import GlobalSettings from "../features/management/GlobalSettings";
import ProductNotifications from "../features/management/Notifications/ProductNotifications";
import FluidNotifications from "../features/management/Notifications/FluidNotifications";
import ViewEvents from "../features/events/ViewEvents";
import SearchComponent from "../features/quick-details/manage/search/SearchComponent";
import ComponentStandardNames from "../features/master-data/machine-templates/ComponentStandardNames";
import NewFluid from "../features/master-data/fluids/NewFluid";
import Laboratories from "../features/management/Laboratories";
import EditComponentModel from "../forms/EditComponentModel";
import PrinterSettings from "../features/management/printer-settings/PrinterSettings";
import AutoEvalProducts from "../features/management/AutoEvalProducts";

import AdhocUnitReport from "../features/quick-details/adhoc-report/AdhocUnitReport";
import AdhocComponentReport from "../features/quick-details/adhoc-report/AdhocComponentReport";

export function useScreenPopups({ dialogType, data, cancel, ...props }) {
  return useMemo(
    function () {
      if (dialogType === DialogTypes.UNIT_HOUR_HISTORY) {
        return {
          title: "Unit Hour History",
          fullWidth: true,
          width: "100vw",
          component: <UnitHourHistory unitId={data?.UnitId} />,
        };
      }

      //Search
      if (dialogType === DialogTypes.SEARCH_REGISTRATION) {
        return {
          title: "Search Registration",
          component: (
            <SearchRegistration
              screen={"useScreenPopups"}
              getRegistration={props.getRegistration}
              searchRegClickHandler={props.searchRegClickHandler}
            />
          ),
          width: "100vw",
          fullWidth: true,
        };
      }

      if (dialogType === DialogTypes.PRIMARY_CONTACTS_OVERVIEW) {
        return {
          title: "Primary Contacts Overview",
          fullWidth: true,
          width: "100vw",
          component: <PrimaryContactOverview formData={data} />,
        };
      }

      if (dialogType === DialogTypes.REPORT_CONTACTS) {
        return {
          title: "Sample Reporting Overview",
          width: "100vw",
          fullWidth: true,
          component: <SampleReportsOverview formData={data} />,
        };
      }

      if (
        dialogType === DialogTypes.WEBSITE_CONTACTS ||
        dialogType === DialogTypes.ACCESS_PERMISSION_OVERVIEW
      ) {
        return {
          title: "Access Permission Overview",
          fullWidth: true,
          width: "100vw",
          component: <AccessPermissionOverview formData={data} />,
        };
      }

      if (dialogType === DialogTypes.CRITIICAL_LOG) {
        return {
          title: `Critical Log ${data?.SampleNumber && data?.SampleNumber ? "for " + data?.SampleNumber : ""}`,
          width: "100vw",
          component: <AddCriticalLogs dataObj={data} />,
        };
      }

      if (dialogType === DialogTypes.HOLD_MANAGEMENT) {
        return {
          title: "Hold Management",
          width: "xl",
          component: (
            <HoldManagement
              SampleNumber={data?.SampleNumber}
              unitId={data?.UnitId}
            />
          ),
        };
      }

      if (dialogType === DialogTypes.ADD_SAMPLE_IMAGES) {
        return {
          title: "Add Image",
          width: "xl",
          component: <SelectImage sampleId={data?.SampleNumber || 0} />,
        };
      }

      if (dialogType === DialogTypes.ADD_NEW_CUSTOMER) {
        return {
          title: "Add Customer",
          component: (
            <EditCustomer
              cancel={cancel}
              newCustomer={props?.newCustomer}
              handleSearchTree={props?.handleSearchTree}
              startLetter={data?.StartLetter !== undefined ? data?.StartLetter : props?.startLetter}
              prodId={data?.ProductId}
              setExpandTreeData={props?.setExpandTreeData}
            />
          ),
        };
      }

      if (dialogType === DialogTypes.EDIT_CUSTOMER) {
        return {
          title: "Edit Customer",
          component: (
            <EditCustomer
              cancel={cancel}
              prodId={data?.ProductId}
              custId={data?.CustomerId}
              startLetter={data?.StartLetter !== undefined ? data?.StartLetter : props?.startLetter}
              handleSearchTree={props?.handleSearchTree}
              setExpandTreeData={props?.setExpandTreeData}
            />
          ),
        };
      }

      if (dialogType === DialogTypes.ADD_NEW_SITE) {
        return {
          title: "Add Site",
          component: (
            <EditSite
              cancel={cancel}
              productId={data?.ProductId}
              customerId={data?.CustomerId}
              customer={data?.Customer}
              startLetter={data?.StartLetter !== undefined ? data?.StartLetter : props?.startLetter}
              setExpandTreeData={props?.setExpandTreeData}
              handleSearchTree={props?.handleSearchTree}
            />
          ),
        };
      }

      if (dialogType === DialogTypes.EDIT_SITE) {
        return {
          title: "Edit Site",
          component: (
            <EditSite
              cancel={cancel}
              customerId={data?.CustomerId}
              siteId={data?.SiteId}
              startLetter={data?.StartLetter !== undefined ? data?.StartLetter : props?.startLetter}
              setExpandTreeData={props?.setExpandTreeData}
              handleSearchTree={props?.handleSearchTree}
            />
          ),
        };
      }

      if (dialogType === DialogTypes.ADD_NEW_UNIT) {
        return {
          title: "Add Unit",
          width: "xl",
          component: (
            <EditUnit
              cancel={cancel}
              unitData={{
                ProductId: data?.ProductId,
                Product: data?.Product,
                CustomerId: data?.CustomerId,
                Customer: data?.Customer,
                SiteId: data?.SiteId,
                Site: data?.Site,
                StartLetter: data?.StartLetter
              }}
              startLetter={data?.StartLetter !== undefined ? data?.StartLetter : props?.startLetter}
              setExpandTreeData={props?.setExpandTreeData}
              handleSearchTree={props?.handleSearchTree}
            />
          ),
        };
      }

      if (dialogType === DialogTypes.EDIT_UNIT) {
        return {
          title: "Edit Unit",
          width: "xl",
          component: (
            <EditUnit
              cancel={cancel}
              unitData={{
                ProductId: data?.ProductId,
                Product: data?.Product,
                CustomerId: data?.CustomerId,
                Customer: data?.Customer,
                SiteId: data?.SiteId,
                Site: data?.Site,
                UnitId: data?.UnitId,
                StartLetter: data?.StartLetter,
              }}
              startLetter={data?.StartLetter !== undefined ? data?.StartLetter : props?.startLetter}
              setExpandTreeData={props?.setExpandTreeData}
              handleSearchTree={props?.handleSearchTree}
            />
          ),
        };
      }

      if (dialogType === DialogTypes.ADD_NEW_COMPONENT) {
        return {
          title: "Add Component",
          component: (
            <EditComponent
              cancel={cancel}
              productId={data?.ProductId}
              customerId={data?.CustomerId}
              siteId={data?.SiteId}
              unitId={data?.UnitId}
              startLetter={data?.StartLetter !== undefined ? data?.StartLetter : props?.startLetter}
              setExpandTreeData={props?.setExpandTreeData}
              handleSearchTree={props?.handleSearchTree}
            />
          ),
        };
      }

      if (dialogType === DialogTypes.EDIT_COMPONENT) {
        return {
          title: "Edit Component",
          component: (
            <EditComponent
              cancel={cancel}
              productId={data?.ProductId}
              customerId={data?.CustomerId}
              siteId={data?.SiteId}
              unitId={data?.UnitId}
              compId={data?.ComponentId}
              startLetter={data?.StartLetter !== undefined ? data?.StartLetter : props?.startLetter}
              setExpandTreeData={props?.setExpandTreeData}
              handleSearchTree={props?.handleSearchTree}
            />
          ),
        };
      }

      if (dialogType === DialogTypes.EDIT_SAMPLE) {
        return {
          title: `Edit Sample ${data?.SampleNumber}`,
          width: "100vw",
          component: (
            <EditSample
              sampleNo={data?.SampleNumber}
              reLoadViewHandler={props?.reLoadViewHandler}
              filterData={props?.filterData}
              cancel={cancel}
            />
          ),
        };
      }

      if (dialogType === DialogTypes.REPORTS_BY_DATE) {
        return {
          title: "Product History and Subscription Reports",
          width: "xl",
          component: <SubscriptionReports />,
        };
      }

      if (dialogType === DialogTypes.EXPORT_CONTACTS_OVERVIEW) {
        return {
          title: "Export Contacts Overview",
          width: "100vw",
          component: <ContactExports treeData={data} />,
        };
      }
      if (dialogType === DialogTypes.VIEW_EVENT) {
        return {
          title: "Events",
          width: "100vw",
          component: <ViewEvents dataObj={data}
            startLetter={data?.StartLetter !== undefined ? data?.StartLetter : props?.startLetter}
            setExpandTreeData={props?.setExpandTreeData}
            handleSearchTree={props?.handleSearchTree}
          />,
        };
      }
      if (dialogType === DialogTypes.EDIT_EVENT) {
        return {
          title: "Edit Events",
          width: "100vw",
          component: <EditEvent
            eventFilter={data}
            fetchData={props?.fetchData}
            cancel={cancel}
            startLetter={data?.StartLetter !== undefined ? data?.StartLetter : props?.startLetter}
            setExpandTreeData={props?.setExpandTreeData}
            handleSearchTree={props?.handleSearchTree}
          />,
        };
      }
      if (dialogType === DialogTypes.ADD_EVENT) {
        return {
          title: "Edit Events",
          width: "100vw",
          component: <EditEvent
            eventFilter={{ ...data, addNew: true }}
            fetchData={props?.fetchData}
            cancel={cancel}
            startLetter={data?.StartLetter !== undefined ? data?.StartLetter : props?.startLetter}
            setExpandTreeData={props?.setExpandTreeData}
            handleSearchTree={props?.handleSearchTree}
          />,
        };
      }
      if (dialogType === DialogTypes.EDIT_TRAY) {
        return {
          title: "Tray Overview",
          width: "xl",
          component: <EditTray eventFilter={data} />,
        };
      }

      if (dialogType === DialogTypes.SUBSCRIPTION_OVERVIEW) {
        return {
          title: "Subscription Overview",
          width: "100vw",
          component: <SubscriptionOverview formData={data} />,
        };
      }

      if (dialogType === DialogTypes.UNITS_NO_RECENT_SAMPLES) {
        return {
          title: "Units With No Recent Samples",
          width: "100vw",
          component: <UnitsRecentSamples formData={data} />,
        };
      }

      //MANAGE
      if (dialogType === DialogTypes.MANAGE_COMPONENT) {
        return {
          title: `Component Management ${data?.Component || ""}`,
          width: "100vw",
          component: <ManageComponent unit={data} close={cancel} handleSearchTree={props?.handleSearchTree}
          />,
        };
      }

      if (dialogType === DialogTypes.MANAGE_CUSTOMER) {
        return {
          title: `Customer Management ${data?.Customer || ""}`,
          width: "100vw",
          component: <ManageCustomer unit={data} close={cancel} handleSearchTree={props?.handleSearchTree}
          />,
        };
      }
      if (dialogType === DialogTypes.MANAGE_SAMPLE) {
        return {
          title: `Sample Management ${data?.SampleNumber || ""}`,
          width: "100vw",
          component: <ManageSample unit={data} close={cancel} handleSearchTree={props?.handleSearchTree}
          />,
        };
      }
      if (dialogType === DialogTypes.MANAGE_SITE) {
        return {
          title: `Site Management ${data?.Site || ""}`,
          width: "100vw",
          component: <ManageSite unit={data} close={cancel} handleSearchTree={props?.handleSearchTree}
          />,
        };
      }
      if (dialogType === DialogTypes.MANAGE_UNIT) {
        return {
          title: `Unit Management ${data?.Unit || ""}`,
          width: "100vw",
          component: <ManageUnit unit={data} close={cancel} handleSearchTree={props?.handleSearchTree}
          />,
        };
      }
      //MANAGE

      if (dialogType === DialogTypes.COMPONENTS_NO_RECENT_SAMPLES) {
        return {
          title: "Components With No Recent Samples",
          width: "100vw",
          fullWidth: true,
          component: <ComponentsRecentSamples formData={data} />,
        };
      }

      if (dialogType === DialogTypes.RECENT_UNIT_RESULTS) {
        return {
          title: "Recent Unit History",
          width: "100vw",
          component: (
            <RecentUnitResults
              allData={data}
            />
          ),
        };
      }
      if (dialogType === DialogTypes.ADHOC_UNIT_REPORT) {
        return {
          title: "Adhoc Unit Report",
          width: "100vw",
          component: (
            <AdhocUnitReport
              allData={data}
            />
          ),
        };
      }
      if (dialogType === DialogTypes.ADHOC_COMPONENT_REPORT) {
        return {
          title: "Adhoc Component Report",
          width: "100vw",
          component: (
            <AdhocComponentReport
              allData={data}
            />
          ),
        };
      }

      if (dialogType === DialogTypes.RECENT_COMPONENT_RESULTS) {
        return {
          title: "Recent Component History",
          width: "100vw",
          component: (
            <RecentComponentResults
              allData={data}
            />
          ),
        };
      }
      if (dialogType === DialogTypes.SPECIAL_REPORT || dialogType === DialogTypes.SPECIAL_COMPONENT_REPORT || dialogType === DialogTypes.SPECIAL_UNIT_REPORT|| dialogType === DialogTypes.EDIT_SPECIAL_COMPONENT_REPORT || dialogType === DialogTypes.EDIT_SPECIAL_UNIT_REPORT) {
        return {
          title: "Special Report from Quick Details",
          width: "md",
          component: (
            <SpecialReport sampleNumber={data?.SampleNumber} allData={data} />
          ),
        };
      }

      if (dialogType === DialogTypes.SEARCH_FLUID) {
        return {
          title: "Search Fluid",
          component: (
            <SearchFluid
              cancel={cancel}
              actions={[
                {
                  action: props.selectFluid,
                  label: "Select",
                },
                {
                  action: props.editFluid,
                  label: "Edit",
                  sx: { marginLeft: "5px" }
                },
              ]}
              propsFluidData={data}
            />
          ),
        };
      }
      if (dialogType === DialogTypes.SEARCH_COMPONENT) {
        return {
          title: "Select Component",
          width: "xl",
          component: (
            <SearchComponent
              selectedUnit={data}
              actions={[
                {
                  action: props.selectComponent,
                  label: "Select",
                },
              ]}

              cancel={cancel}
            />
          ),
        };
      }
      if (dialogType === DialogTypes.UPDATE_TRAY_LABEL) {
        return {
          title: "Tray Details",
          width: "md",
          fullWidth: true,
          component: (
            < UpdateTrayLabel
              rowData={data}
              cancel={cancel}
              onView={props?.onView}
            />
          ),
        };
      }
      if (dialogType === DialogTypes.SEARCH_GENERAL) {
        return {
          title: "Search from Quick Details",
          width: "100vw",
          fullWidth: true,
          component: (
            <SearchGeneral handleSearchTree={props?.handleSearchTree} />
          ),
        };
      }
      if (dialogType === DialogTypes.MANAGEMENT_REPORT) {
        return {
          title: "Management Report",
          width: "md",
          component: (
            <ManagementReport cancel={cancel} />
          ),
        };
      }
      if (dialogType === DialogTypes.EDIT_BILLING_RATES) {
        return {
          title: "Edit Billing Rates",
          width: "md",
          component: (
            <EditBillingRates cancel={cancel} />
          ),
        };
      }
      if (dialogType === DialogTypes.GLOBAL_SETTINGS) {
        return {
          title: "Global Settings",
          width: "md",
          component: (
            <GlobalSettings cancel={cancel} />
          ),
        };
      }
      if (dialogType === DialogTypes.FLUIDTYPE_NOTIFICATIONS) {
        return {
          title: "Fuid Type Notifications",
          width: "lg",
          component: (
            <FluidNotifications cancel={cancel} />
          ),
        };
      }
      if (dialogType === DialogTypes.PRODUCT_NOTIFICATIONS) {
        return {
          title: "Product Notifications",
          width: "lg",
          component: (
            <ProductNotifications cancel={cancel} />
          ),
        };
      }
      if (dialogType === DialogTypes.AUTOEVAL_PRODUCTS) {
        return {
          title: "AutoEval Products",
          width: "lg",
          component: (
            <AutoEvalProducts cancel={cancel} />
          ),
        };
      }
      if (dialogType === DialogTypes.PRINTER_SETTINGS) {
        return {
          title: "Printer Settings",
          width: "lg",
          component: (
            <PrinterSettings cancel={cancel} />
          ),
        };
      }
      if (dialogType === DialogTypes.ADMIN_LABORATORIES) {
        return {
          title: "Laboratories",
          width: "md",
          component: (
            <Laboratories cancel={cancel} />
          ),
        };
      }
      if (dialogType === DialogTypes.STANDARD_NAMES) {
        return {
          title: "Standard Component Names",
          width: "md",
          component: (
            <ComponentStandardNames
              recordSelected={props?.recordSelected}
              cancel={cancel}
            />),
        };
      }
      if (dialogType === DialogTypes.EDIT_COMPONENT_MODEL) {
        return {
          title: "Make and Models",
          width: "md",
          component: (
            <EditComponentModel
              fetchComponentModels={props?.fetchComponentModels}
              cancel={cancel}
            />),
        };
      }
      if (dialogType === DialogTypes.NEW_FLUID) {
        return {
          title: "New Fluid",
          width: "md",
          component: (
            <NewFluid
              cancel={cancel}
              fetchFluidsDetails={props?.fetchAllFluids}
            />),
        };
      }

      else return;
    },
    [dialogType, data, props, cancel]
  );
}

export const DialogTypes = {
  UPDATE_TRAY_LABEL: "update-tray-label",
  UNIT_HOUR_HISTORY: "unit-hour-history",
  SUBSCRIPTION_OVERVIEW: "subscription-overview",
  ACCESS_PERMISSION_OVERVIEW: "access-permission-overview",
  PRIMARY_CONTACTS_OVERVIEW: "primary-contacts-overview",
  EXPORT_CONTACTS_OVERVIEW: "export-contacts-overview",
  REPORT_CONTACTS: "report-contacts",
  WEBSITE_CONTACTS: "website-contacts",
  CRITIICAL_LOG: "critical-log",
  HOLD_MANAGEMENT: "hold-management",
  REPORTS_BY_DATE: "reports-by-date",
  UNITS_NO_RECENT_SAMPLES: "units-no-recent-samples",
  COMPONENTS_NO_RECENT_SAMPLES: "components-no-recent-samples",
  RECENT_UNIT_RESULTS: "recent-unit-results",
  ADHOC_UNIT_REPORT:"adhoc-unit-report",
  ADHOC_COMPONENT_REPORT:"adhoc-component-report",
  RECENT_COMPONENT_RESULTS: "recent-component-results",
  SPECIAL_REPORT: "special-report",
  SPECIAL_UNIT_REPORT: "special-unit-report",
  SPECIAL_COMPONENT_REPORT: "special-component-report",
  EDIT_SPECIAL_UNIT_REPORT: "edit-special-unit-report",
  EDIT_SPECIAL_COMPONENT_REPORT: "edit-special-component-report",
  VIEW_EVENT: "view-event",

  EDIT_SAMPLE: "edit-sample",
  EDIT_COMPONENT: "edit-component",
  EDIT_UNIT: "edit-unit",
  EDIT_SITE: "edit-site",
  EDIT_CUSTOMER: "edit-customer",
  EDIT_EVENT: "edit-event",
  EDIT_TRAY: "edit-tray",

  ADD_NEW_CUSTOMER: "add-new-customer",
  ADD_NEW_COMPONENT: "add-new-component",
  ADD_NEW_UNIT: "add-new-unit",
  ADD_NEW_SITE: "add-new-site",
  ADD_SAMPLE_IMAGES: "add-sample-images",
  ADD_EVENT: "add-event",

  MANAGE_COMPONENT: "manage-component",
  MANAGE_CUSTOMER: "manage-customer",
  MANAGE_SAMPLE: "manage-sample",
  MANAGE_SITE: "manage-site",
  MANAGE_UNIT: "manage-unit",

  SEARCH_REGISTRATION: "search-registration",
  SEARCH_COMPONENT: "search-component",
  SEARCH_FLUID: "search-fluid",
  SEARCH_GENERAL: "search-general",

  MANAGEMENT_REPORT: "management-report",
  EDIT_BILLING_RATES: "edit-billing-rates",
  GLOBAL_SETTINGS: "global-settings",
  FLUIDTYPE_NOTIFICATIONS: "fluid-type-notifications",
  PRODUCT_NOTIFICATIONS: "product-notifications",
  AUTOEVAL_PRODUCTS: "autoeval-products",
  PRINTER_SETTINGS: "printer-settings",

  ADMIN_LABORATORIES: "admin-laboratories",

  STANDARD_NAMES: "standard-names",
  EDIT_COMPONENT_MODEL: "edit-component-models",
  NEW_FLUID: "new-fluid",
};
